import { apiMap } from '@common/assets/ts/const';
import { get, post, postForm } from '@common/http';
import { useStoreCommon } from '@common/store/common';

// 获取用户信息
export const apiGetUserInfo = () => {
    return postForm<Record<string, any>>(`${apiMap.apiCmnt}/api/v1/activity/user-info`, {need_avatar: 1, need_pendant: 1,});
};

// 首页
export const apiPageData = () => {
    // const storeCommon = useStoreCommon();
    // const config: Record<string, any> = { noToast: true, };
    // if (storeCommon.systemInfo.isIos) {
    //     config.noUseJsb = true;
    // }
    // return get(`${apiMap.apiCmnt}/api/v1/activity/book-extra-festival/index`, {}, config);
    return get(`${apiMap.apiCmnt}/api/v1/activity/book-extra-festival/index`);
};


// 排名列表
export const apiGetRankingList = (params: Record<string, any>) => {
    return get(`${apiMap.apiCmnt}/api/v1/activity/book-extra-festival/rank`, params);
};

// 书籍详情
export const apiGetBookDetail = (params: Record<string, any>) => {
    return post(`${apiMap.apiCmnt}/api/v1/activity/batch-get-book-info`, params, { noUseJsb: true, });
};

// 搜索
export const apiSearch = (params: Record<string, any>) => {
    return post(`${apiMap.apiCmnt}/api/v1/activity/book-extra-festival/search-books`, params);
};

// 投票
export const apiVote = (params: Record<string, any>) => {
    return post(`${apiMap.apiCmnt}/api/v1/activity/book-extra-festival/vote`, params);
};

// 获取投票历史
export const apiGetVoteHistory = (params: Record<string, any>) => {
    return get(`${apiMap.apiCmnt}/api/v1/activity/book-extra-festival/vote-record`, params);
};


// 获取奖品弹窗信息
export const apiGetRewardPop = (params: Record<string, any>) => {
    return get(`${apiMap.apiCmnt}/api/v1/activity/reward-pop`, params);
};

// 完成任务
export const apiCompleteTask = (params: Record<string, any>) => {
    return postForm(`${apiMap.apiCmnt}/api/v1/activity/task/finish`, params);
};

// 归因加密
export const apiZhUrl = (params: Record<string, any>) => {const storeCommon = useStoreCommon();
    const config: Record<string, any> = { noToast: true, };
    if (storeCommon.systemInfo.isIos) {
        config.noUseJsb = true;
    }
    return post(`${apiMap.apiCmnt}/api/v1/activity/book-extra-festival/zh-url`, params, config);
};
